export default {"src":"/_next/static/media/AttachmentsIcon.9c264a3b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};